import { jsx } from "react/jsx-runtime";
import ZoomOutMapIcon from "@mui/icons-material/ZoomOutMap";
import { validateTidalLicense } from "../../base/index.js";
function ZoomOutMap(props) {
  return /* @__PURE__ */ jsx(
    ZoomOutMapIcon,
    {
      "data-testid": "ZoomOutMap",
      ...props,
      "data-tidal": "TidalIcon",
      "data-tidal-icon": "ZoomOutMap",
      "data-tidal-icon-meta": "map,location,time"
    }
  );
}
ZoomOutMap.tidalIconMeta = {
  categories: "map,location,time",
  name: "ZoomOutMap"
};
validateTidalLicense();
export {
  ZoomOutMap
};
//# sourceMappingURL=ZoomOutMap.js.map
